<script setup lang="ts">
import "~/assets/css/dashboard-main.css";
import "~/assets/css/cb_custom.css";
import MobileHeader from "~/components/Navigation/MobileHeader.vue";
import NavMenu from "~/components/Navigation/NavMenu.vue";
import TopHeaderBar from "~/components/Navigation/TopHeaderBar.vue";

// TODO: move somewhere else
useUserStore();
useFacilityStore();
useCareDayStore();
useMenuStore();

const isMenuOpen = ref(false);
const isOpenOnClick = ref(false);

const toggleMenu = () => {
  isOpenOnClick.value = !isOpenOnClick.value;
  isMenuOpen.value = isOpenOnClick.value;
};

const onMouseEnter = () => {
  if (isOpenOnClick.value) {
    return;
  }
  isMenuOpen.value = true;
};

const onMouseLeave = () => {
  if (isOpenOnClick.value) {
    return;
  }
  isMenuOpen.value = false;
};

const isMobileView = ref(window.innerWidth < 926);
const handleResize = () => {
  isMobileView.value = window.innerWidth < 926;
};

onMounted(() => {
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<template>
  <div :class="[{ 'default-container': !isMobileView }]">
    <NavMenu
      v-if="!isMobileView"
      :is-menu-open="isMenuOpen"
      @menu-click="toggleMenu"
      @on-mouse-enter="onMouseEnter"
      @on-mouse-leave="onMouseLeave"
    />
    <MobileHeader v-else />
    <div :class="['content-default']">
      <div class="container">
        <TopHeaderBar v-if="!isMobileView" />
        <slot />
      </div>
    </div>
  </div>
</template>

<style scoped>
.default-container {
  height: 100vh;
  width: 100vw;
}

.content-default {
  height: 100%;
  width: calc(100% - 88px);
  margin-left: auto;
}

@media (max-width: 925px) {
  .content-default {
    width: 100%;
  }
}
</style>
